// SortingTable.js
import React, { useEffect, useState } from "react";
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";

import LiveIcon from "../../../assets/icons/ic_live.svg";

import "./stylesSortingTable.css";

import CategoryRow from "../CategoryRow/CategoryRow";

const SortingTable = ({
  columns,
  data,
  setData,
  toggleStatus,
  removeGame,
  setRemovingGameData,
  etype,
  allGames,
  addGameInCasinoEntity,
  toggleCasinoEntityStatus,
  changeCasinoEntityOrder,
  EditGameIcon
}) => {
  const casinoGames = data;

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor)
  );

  const handleDragEnd = async (event) => {
    const { active, over } = event;

    if (!over) return;

    if (active.id !== over.id) {
      const oldIndex = casinoGames.findIndex((c) => c.id === active.id);
      const newIndex = casinoGames.findIndex((c) => c.id === over.id);
      setData(arrayMove(casinoGames, oldIndex, newIndex));
      await changeCasinoEntityOrder({
        name: active.id,
        order: newIndex + 1,
        etype: etype,
      });
      console.log("MOVED", active.id, newIndex, etype);
    }
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <SortableContext
        items={casinoGames.map((c) => c.id)}
        strategy={verticalListSortingStrategy}
      >
        <table className="sorting-table">
          <thead>
            <tr className="sorting-table-header-row">
              {columns.map((column) => {
                return (
                  <th className="sorting-table-header-cell">
                    <div className="sorting-table-header-cell-content">
                      <span>{column}</span>
                      {/* <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/cd32e60c936c289aaadc4ebec51cb61d5c2e0422e2b12c7e1eccef3165d835e4?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200"
                        alt="Sort"
                        className="sortIcon"
                      /> */}
                    </div>
                  </th>
                );
              })}
              <th className="sorting-table-header-cell">
                <div className="sorting-table-header-cell-content"></div>
              </th>
            </tr>
          </thead>
          <tbody>
            {casinoGames.map((category, index) => (
              <CategoryRow
                key={category.id}
                category={category}
                setCasinoGames={setData}
                order={index + 1}
                toggleStatus={toggleStatus}
                removeGame={removeGame}
                setRemovingGameData={setRemovingGameData}
                etype={etype}
                allGames={allGames}
                addGameInCasinoEntity={addGameInCasinoEntity}
                categories={data}
                toggleCasinoEntityStatus={toggleCasinoEntityStatus}
                EditGameIcon={EditGameIcon}
              />
            ))}
          </tbody>
        </table>
      </SortableContext>
    </DndContext>
  );
};

export default SortingTable;
